export default __webpack_public_path__ + "static/React-2a0cac33f155e4a27216938484e8116b.webp";